import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
// import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"
import Login from "./reducers/authReducer"
import Alert from "./reducers/alertReducer"
import Bookings from "./reducers/bookingReducer"
import JobApplication from "./reducers/jobApplicationReducer"
import Interviews from "./reducers/interviewsReducer.js"
import Common from "./reducers/commonReducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Alert,
  Login,
  Account,
  ForgetPassword,
  Profile,
  Bookings,
  JobApplication,
  Interviews,
  Common,
})

export default rootReducer
